if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.addOnToggle = this.querySelectorAll('input.addon-product-toggle')
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      if(this.addOnToggle) {
        this.addOnToggle.forEach(addOnToggle => {
          addOnToggle.addEventListener('change', e => {
            const target = e.currentTarget
            if(!target.checked) {
              const wrapper = target.closest('.additional-props')
              const inputs = wrapper.querySelectorAll('input[type="text"]')
              inputs.forEach(input => {
                if(input.classList.contains('input-number')) {
                  input.value = 0
                  const product_handle = input.dataset.handle
                  const hiddenInput = document.querySelector(`input[name="properties[Accessories][${product_handle}]"]`)
                  if(hiddenInput) {
                    hiddenInput.value = 0
                  }
                  input.dispatchEvent(new Event('change', {bubbles: true}))
                } else {
                  input.value = ""
                  const name = input.getAttribute('name')
                  const hiddenInput = document.querySelector(`input[type="hidden"][name="${name}"]`)
                  if(hiddenInput) {
                    hiddenInput.value = ""
                  }
                }
                input.dispatchEvent(new Event('input', {bubbles: true}))
                // input.dispatchEvent(new Event('change', {bubbles: true}))
              })
            }
          })
        })
      }
    }

    connectedCallback() {
      const messageField = document.querySelector('input#message-on-the-cake');
      if(messageField) {
        messageField.addEventListener('input', e => {
          const value = e.target.value
          if(value != '') {
            const errorEl = e.target.parentElement.querySelector('span.error')
            if(errorEl) {
              errorEl.remove()
            }
          }
        })
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const backdropMsg = this.querySelector('input[name="properties[Message on the backdrop]"]') || document.querySelector('customization-product .line-item-property__field input[name="properties[Message on the cake]"]') || document.querySelector('customization-product .line-item-property__field input[name="properties[Name on the mosque]"]') || document.querySelector('customization-product .line-item-property__field input[name="properties[Message on backdrop]"]')

      const msgOfAddon = document.querySelector('customization-product .line-item-property__field input[name="properties[Message on Giveaway Boxes]"]')
      const addOnToggle = document.querySelector('customization-product input.addon-product-toggle')

      // if (selectedCity.trim() == 'RIYADH') {
      if (backdropMsg && backdropMsg?.value.length == 0) {
        const formField = document.querySelector('input#message-on-the-cake');
        const fieldWrapper = formField?.closest('.line-item-property__field');
        const errorEl = fieldWrapper?.querySelector('span.error');
        if (errorEl) {
          fieldWrapper.removeChild(errorEl);
        }
        const messageEl = document.createElement('span');
        let message = backdropMsg.dataset.errorMessage

        if(!backdropMsg.dataset.errorMessage) {
          message = window.errorStrings.errorLabel;
        }

        messageEl.classList.add('error');
        messageEl.innerText = message;
        fieldWrapper?.appendChild(messageEl);
        return;
      }
      // }
      if(addOnToggle && addOnToggle?.checked) {
        if(msgOfAddon && msgOfAddon?.value.length == 0) {
          const formField = document.querySelector('input#message-on-the-addon');
          const fieldWrapper = formField?.closest('.line-item-property__field');
  
          const errorEl = fieldWrapper?.querySelector('span.error');
          if (errorEl) {
            fieldWrapper.removeChild(errorEl);
          }
          const messageEl = document.createElement('span');

          let message = msgOfAddon.dataset.errorMessage;
          if(!msgOfAddon.dataset.errorMessage) {
            message = window.errorStrings.errorLabel;
          }
          messageEl.classList.add('error');
          messageEl.innerText = message;
          fieldWrapper?.appendChild(messageEl);
          return;
        }
      }

      // gender selector error
      const genderSelector = this.querySelector('input[name="properties[Choose Gender]"]');
      if (genderSelector) {
        if (genderSelector?.value.length == 0) {
          document.querySelector('#genderErrorMsg')?.classList.remove('hidden');
          return;
        } else {
          document.querySelector('#genderErrorMsg')?.classList.add('hidden');
        }
      }
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData();
      const formDataMain = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        formDataMain.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formDataMain.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

      }



      config.body = formData;

      if (this.id == 'packageProduct') {

        for (const pair of formDataMain.entries()) {
          const key = pair[0];
          if (key.includes("properties")) {
            formData.append(`items[0][properties]${key.replace("properties", "")}`, pair[1])
          }
        }

        formData.append("items[0][id]", formDataMain.get("id"))
        formData.append("items[0][quantity]", formDataMain.get("quantity") ?? 1)

        Shopify.theme.cart.getState().then(async (res) => {
          let items = res.items;
          let product_id = formDataMain.get('product_id');
          let itemExists = false;
          let key = '';
          let line = 0;


          if (items.length > 0) {
            items.map((item, index) => {
              if (item.product_id == product_id) {
                itemExists = true;
                line = index;
                key = item.key;
              }
            });
          }

          let localStoragEditProduct = localStorage.getItem('edit-product');

          // Clicked Edit and has same variant id to update
          if (itemExists && formDataMain.get("id") == localStoragEditProduct) {
            var object = {};

            function buildObjectFromFormKey(key, value, obj = {}) {
              const keys = key.split(/\[|\]|\./).filter(Boolean);
              const lastKeyIndex = keys.length - 1;
              keys.reduce((acc, currKey, index) => {
                if (!acc[currKey]) {
                  if (index === lastKeyIndex) {
                    acc[currKey] = value;
                  } else {
                    acc[currKey] = {};
                  }
                }

                return acc[currKey];
              }, obj);

              return obj;
            }

            formData.forEach(function (value, key) {
              if (key.startsWith('items[0]')) {
                object = buildObjectFromFormKey(key, value, object);
              }
            });

            object = { ...object.items[0] };
            object['id'] = formDataMain.get("id");
            object['key'] = key;
            object['sections'] = formDataMain.get("sections");
            object['sections_url'] = formDataMain.get("sections_url");

            const payload = object;
            config.body = object;

            const options = {
              "properties": payload.properties,
              "quantity": 1,
              "id": parseInt(payload.id)
            };

            Shopify.theme.cart.updateItem(payload.key, options)
              .then((res) => {
                if (res) {
                  document.dispatchEvent(new CustomEvent("cart:update", { detail: { cart: res } }));
                  const cartDrawer = document.querySelector('cart-drawer');
                  cartDrawer?.classList.toggle('is-empty', res.item_count === 0);
                }
              })
              .catch((err) => console.log("Error", err))
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              });

            return false;
          }

          // Clicked Edit but has diffrent variant id to update
          if (itemExists && formDataMain.get("id") != localStoragEditProduct && localStoragEditProduct != null) {
            var productCartkey = key;
            Shopify.theme.cart.removeItem(productCartkey).then((res) => {
              const localstorageindex = localStorage.getItem('edit-product-index');
              if (localstorageindex == this.dataset.index) {
                document.querySelector('variant-radios')?.onVariantChange();
                // this.removeEditLocalStorage()
              }
              this.addNewItemtoCart(config);
            }).catch((err) => console.log("Error", err));

            return false;
          }

          // Not click Edit but has same Product in Cart
          if (itemExists) {
            Shopify.theme.cart.removeItem(key).then((res) => {
              const localstorageindex = localStorage.getItem('edit-product-index');
              if (localstorageindex == line) {
                document.querySelector('variant-radios')?.onVariantChange();
                // this.removeEditLocalStorage();
              }
            }).then(() => {
              this.addNewItemtoCart(config);
            }).catch((err) => console.log("Error", err));

            return false;
          }

          // Add New Package Product
          if (!itemExists) {
            const addonArray = [1, 2, 3];
            addonArray.forEach((ind) => {
              const dataform = formDataMain.get(`properties[_pdp_addon_${ind}]`);
              if (!dataform) return;
              const id = dataform.split(":")[0]
              const qty = parseInt(dataform.split(":")[1]) ?? 1;
              const Producthandle = this.dataset.handle;

              formData.append(`items[${ind}][id]`, id)
              formData.append(`items[${ind}][quantity]`, qty)
              formData.append(`items[${ind}][properties][_addonProduct]`, true)
              formData.append(`items[${ind}][properties][_package]`,Producthandle)
            });
            document.querySelector('variant-radios')?.onVariantChange();
            config.body = formData;
            this.addNewItemtoCart(config);

            return false;
          }

        });
      } else {
        config.body = formDataMain;
        Shopify.theme.cart.getState().then(async (res) => {
          let items = res.items;
          let product_id = formDataMain.get('product_id');
          let itemExists = false;
          let key = '';
          let line = 0;

          if (items.length > 0) {
            items.map((item, index) => {
              if (item.product_id == product_id) {
                itemExists = true;
                line = index;
                key = item.key;
              }
            });
          }

          // click on Edit or Add same product
          if (itemExists) {
            Shopify.theme.cart.removeItem(key).then((res) => {
              const localstorageindex = localStorage.getItem('edit-product-index');
              if (localstorageindex == line) {
                document.querySelector('variant-radios')?.onVariantChange();
                // this.removeEditLocalStorage();
              }
            }).then(() => {
              this.addNewItemtoCart(config);
            }).catch((err) => console.log("Error", err));

            return false;
          }

          // Add New Product
          if (!itemExists) {
            this.addNewItemtoCart(config);
            return false;
          }

        });

      }
      setTimeout(function () {
        document.querySelector('variant-radios')?.onVariantChange();
      }, 1500);
    }

    removeEditLocalStorage() {
      localStorage.removeItem('edit-product');
      localStorage.removeItem('edit-product-index');
      localStorage.removeItem('edit-product-handle');
      localStorage.removeItem('edit-product-key');
    }

    addNewItemtoCart(config) {
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            if (response.items.length == 1) {
              var formData = new FormData();
              formData.append("attributes[Gift wrap]", "Yes");
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
              })
                .then(response => response.json())
                .then(data => console.log(data));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
if (!customElements.get('product-form')) {
  class DynamicDescription extends HTMLElement {
    constructor() {
      super()
      this.descriptions = this.querySelectorAll('.variant_description')
    }

    connectedCallback() {
      document.addEventListener('variant:change', this.updateDescription.bind(this))
    }

    updateDescription(e) {
      const variant = e.detail.variant
      const id = variant.id

      this.descriptions.forEach(item => {
        const variantId = parseInt(item.dataset.variantId)
        if(variantId == id) {
          item.classList.remove('hidden')
        } else {
          item.classList.add('hidden')
        }
      })
    }
  }
  customElements.define('dynamic-description', DynamicDescription)
}